/***
 * 单选接口获取数据
 */

import React from 'react';
import { Select } from 'antd';

class ProdcutLabel extends React.PureComponent {
  componentDidMount() {}

  render() {
    const { AddCodeData } = this.props;

    return (
      <Select
        tokenSeparators={[' ']}
        optionFilterProp="children"
        allowClear
        showSearch
        placeholder={'请选择'}
        {...this.props}>
        {AddCodeData.map(item => (
          <Select.Option key={item.key} value={item.value}>
            {item.key}
            {item.value}
          </Select.Option>
        ))}
      </Select>
    );
  }
}

export default ProdcutLabel;
